import React from 'react';
import { Typography } from '@mui/material';
import BrandMark from './BrandMark';

export default function AppLoadingScreen({ isFrench = true, preview = false }) {
  return (
    <div
      className={preview ? 'app-loading app-loading--preview' : 'app-loading'}
      role="status"
      aria-live="polite"
    >
      <div className="app-loading-lockup" aria-hidden="true">
        <BrandMark className="brand-mark brand-mark--loader" />
        <span className="app-loading-wordmark">CourtClic</span>
      </div>
      <span className="app-loading-progress" aria-hidden="true"><span /></span>
      <Typography className="app-loading-copy">
        {isFrench
          ? 'On prépare votre prochain match…'
          : 'Getting your next match ready…'}
      </Typography>
    </div>
  );
}
